import * as dayjs from 'dayjs';

export function convertDateToMonthlyReportLabel(current_period: string, current_format: string) {
  const temp_date = dayjs(current_period, current_format, true);
  return temp_date.format('MMM-YYYY');
}
